import * as React from 'react';
import PropTypes from 'prop-types';

// A small pill showing which project a (cross-project) search result belongs to.
// Search spans every project the user can see, so without this a multi-project
// user can't tell which project a match lives in. Renders nothing when the name
// is unknown (single-project users pass null, so it stays out of the way).
export default function ProjectBadge({ name }) {
  if (!name) return null;
  return (
    <span
      className="proj-badge"
      data-testid="result-project-badge"
      title={`Project: ${name}`}
      style={{
        fontSize: 11,
        padding: '1px 6px',
        borderRadius: 5,
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        maxWidth: 160,
        border: '1px solid var(--border)',
        color: 'var(--muted, #6b7280)',
        flexShrink: 0,
      }}
    >
      {name}
    </span>
  );
}

ProjectBadge.propTypes = {
  name: PropTypes.string,
};
